import React, { useContext } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Dropdown } from "react-bootstrap";
import ClientsTableComponent from "../tables/ClientsTableComponent";
import clients from "../../assets/data/clients.json";

export default function ClientsCardComponent({ data = [], title }) {
    const { t } = useContext(TranslatorContext);
    const NewClientData = {
        "thead": ["Tài Khoản", "Hình Thức", "Số Tiền", "Hành Động"],
        
    }
   
    // Chuyển đổi dữ liệu mới thành cấu trúc phù hợp với ClientsTableComponent
    const transformedData = data.map(item => ({
        id: `#${item.userId}`,
        src: "images/avatar/03.webp", // Bạn có thể thêm đường dẫn hình ảnh nếu có
        alt: "client",
        name: item.username,
        order: title, // Bạn có thể thêm thông tin đơn hàng nếu có
        amount: item.total.toLocaleString(),
        action: { chat: "chat", view: "visibility" }
    }));

    return (
        <div className="mc-card">
            <div className="mc-card-header">
                <h4 className="mc-card-title">{t(title)}</h4>
                <Dropdown bsPrefix="mc-dropdown">
                    <Dropdown.Toggle bsPrefix="mc-dropdown-toggle">
                        <i className='material-icons'>more_horiz</i>
                    </Dropdown.Toggle>
                    <Dropdown.Menu align="end" className="mc-dropdown-paper">
                        <button type='button' className='mc-dropdown-menu'><i className='material-icons'>edit</i><span>{t('edit')}</span></button>
                        <button type='button' className='mc-dropdown-menu'><i className='material-icons'>delete</i><span>{t('delete')}</span></button>
                        <button type='button' className='mc-dropdown-menu'><i className='material-icons'>download</i><span>{t('download')}</span></button>
                    </Dropdown.Menu>
                </Dropdown>
            </div>
            <ClientsTableComponent 
                thead={NewClientData.thead} 
                tbody={transformedData} 
            />
        </div>
    );
}